import { memo } from "react";
import HomePage from "./Pages/Home";
const App = () => {
  return <>
    <HomePage />

  </>
}
export default memo(App);